import { createActionCreator } from '../../lib/Actions/factory';

const createAction = createActionCreator('PERSISTED_STATE');

export const SET_PERSISTED_STATE = createAction('SET_PERSISTED_STATE', data => data);
export const UNSET_PERSISTED_STATE = createAction('UNSET_PERSISTED_STATE', data => data);
